export const NOT_SET = Symbol("NOT_SET");
export const UPLOAD_STORE_NAME = "upload";
